import { TagCategory } from '../Model/ExerciseTag';

/**
 * Maps exercise tag docs to the option shape used by the tags
 * MultiSelectAutoComplete (platform tags are visible but not selectable).
 */
const buildTagOptions = (tagDocs) => (tagDocs || []).map((doc) => ({
  id: doc.id,
  label: doc.tag.toLowerCase(),
  disabled: doc.category === TagCategory.PLATFORM,
  category: doc.category,
}));

export { buildTagOptions };
